import { useGLTF } from '@react-three/drei'

var url = './3DModels/Programming_Ch/Programming_Ch.gltf';

export default function Character(props) {
    const { nodes } = useGLTF(url)

    return(
        <>

            <mesh
                scale = {[10.0,10.0,10.0]}
                position={[0.06,-0.16,0.58]}
                rotation={[-1.57,0,0.0]}
                geometry={nodes.Engines001003.geometry}
            >

                <meshStandardMaterial attach="material" color={props.data.stdMatColor} roughness={props.data.roughness}   metalness={props.data.metalness} />

            </mesh>
        </>
    )

}

useGLTF.preload(url)